import React from "react";
import Image from "next/image";

import { Paragraph } from "@/components/ui/typography";
import Link from "@/components/link";

function BundleCourse({ course }) {
  return (
    <Link
      href={`/course-detail/${course.courseSlug || course.slug}`}
      className="flex flex-col border border-grayscale-input rounded-xl overflow-hidden"
    >
      <Image
        src={course.thumbnail}
        alt={course.courseTitle}
        width={300}
        height={160}
      />

      <div className="flex flex-col gap-y-1 p-4 rounded-t-xl -mt-3 bg-primary-foreground">
        <Paragraph
          variant="b2-tight"
          weight="sb"
          className="line-clamp-1 text-grayscale-header-weak"
        >
          Validity: {course.validity} Days
        </Paragraph>
      </div>
    </Link>
  );
}

export default BundleCourse;
